import { render } from "./BimPlusAuth.vue?vue&type=template&id=5dd92b42"
import script from "./BimPlusAuth.vue?vue&type=script&lang=js"
export * from "./BimPlusAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__